import { OrderReferralDiscount } from '../types';
import { formatCurrency } from './formatCurrency';

type DiscountTerms = Pick<OrderReferralDiscount, 'status' | 'amount' | 'percent' | 'max_amount'>;

const formatCap = (maxAmount: number) =>
  Number.isInteger(Number(maxAmount)) ? `E${Number(maxAmount)}` : formatCurrency(Number(maxAmount));

export const isReferralDiscountCapped = (deliveryFee: number, discount: DiscountTerms) =>
  discount.status !== 'redeemed' && (Number(deliveryFee) * Number(discount.percent)) / 100 > Number(discount.max_amount);

export const referralDiscountAmount = (deliveryFee: number, discount: DiscountTerms) => {
  if (discount.status === 'redeemed') return Number(discount.amount);
  const raw = Math.min((Number(deliveryFee) * Number(discount.percent)) / 100, Number(discount.max_amount));
  return Math.max(0, Math.round(raw * 100) / 100);
};

export const referralDiscountTerms = (discount: DiscountTerms, capped: boolean) =>
  `${Number(discount.percent)}% off delivery${capped ? `, max ${formatCap(discount.max_amount)}` : ''}`;

export const referralDiscountLabel = (discount: DiscountTerms, capped: boolean) =>
  `Referral Discount (${referralDiscountTerms(discount, capped)})`;

export const formatDiscount = (amount: number) => `−${formatCurrency(Number(amount))}`;
